import React, { useState } from 'react';
import PlanCard from './PlanCard';

const AdvantageView = ({advantage}) => {

  return (
    <div className="tw-flex tw-gap-1">
        <div className='tw-self-start'>
            <i class="fa fa-check tw-h-[0.875rem] tw-w-[0.875rem]" style={{color: '#94BA33'}}></i>
        </div>
        <div className='tw-self-start'>
            <div className='tw-text-[#1a1a1a] tw-font-semibold tw-text-base'>{advantage.title}</div>
            <div className='tw-text-[#1a1a1a] tw-text-base'>{advantage.description}</div>
        </div>
    </div>
  );
};

export default AdvantageView;